import { Icon } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';

const OpenButton = styled.div`
	cursor: pointer;
	margin-left: 5px;
	display: inline-block;
`;

export interface IOwnParams {
	id: number;
	text: string;
}

export interface IConnectedParams {
	OpenModalCallback: (id: number, test: string) => void;
}

export class ModalOpenButton extends React.Component<IOwnParams & IConnectedParams> {
	public render() {
		return (
			<OpenButton onClick={() => this.props.OpenModalCallback(this.props.id, this.props.text)}>
				<Icon name='open-modal' />
			</OpenButton>
		);
	}
}
